import styled from '@emotion/styled';
import { fonts } from '../../../ui';

// On-screen credit card outline for card calibration (Figma P3.2b): gradient top half with
// "Credit Card" and the contactless mark, dark bottom half with YOUR NAME / 06/24 / •••• 8557 / VISA.
// Width/height are the exact pixel size used by the calibration maths - everything inside scales
// with the card (font sizes are relative to the card height).

const Root = styled.div`
  position: relative;
  flex-shrink: 0;
  width: ${({ w }) => w}px;
  height: ${({ h }) => h}px;
  border-radius: ${({ h }) => Math.max(6, h * 0.055)}px;
  overflow: hidden;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.22);
  outline: ${({ submitted }) => (submitted ? '3px solid #10B981' : 'none')};
  outline-offset: 2px;
  font-family: ${fonts.family};
  font-size: ${({ h }) => h / 12}px;
  color: #fff;
  user-select: none;
  .top {
    position: absolute;
    inset: 0 0 45% 0;
    background: repeating-radial-gradient(circle at 115% 120%, rgba(255, 255, 255, 0.16) 0 1px, transparent 1px 7px), linear-gradient(100deg, #7c5cf0 0%, #4f8ff0 45%, #3fd0dc 100%);
    padding: 0.8em 1em;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .brand {
    font-weight: 600;
    font-size: 1.1em;
  }
  .bottom {
    position: absolute;
    inset: 55% 0 0 0;
    background: #1e2433;
    padding: 0.7em 1em;
    box-sizing: border-box;
    font-family: 'SFMono-Regular', Menlo, Consolas, monospace;
    font-size: 0.72em;
    letter-spacing: 0.06em;
    display: grid;
    grid-template-columns: 1fr auto;
    align-content: center;
    row-gap: 0.7em;
  }
  .visa {
    grid-row: 1 / span 2;
    grid-column: 2;
    align-self: center;
    background: #fff;
    color: #1a1f71;
    font-family: ${fonts.family};
    font-style: italic;
    font-weight: 800;
    font-size: 1.2em;
    padding: 0.25em 0.45em;
    border-radius: 0.2em;
  }
`;

const Contactless = ({ size }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' aria-hidden='true'>
    <path d='M8.5 8.5a5 5 0 0 1 0 7M12 6a8.5 8.5 0 0 1 0 12M15.5 3.5a12 12 0 0 1 0 17' />
  </svg>
);

export const CreditCard = ({ width = 355, height = 222, submitted = false, ...rest }) => (
  <Root w={width} h={height} submitted={submitted} role='img' aria-label={`Card outline ${width} by ${height} pixels`} data-testid='calibration-card' {...rest}>
    <div className='top'>
      <span className='brand'>Credit Card</span>
      <Contactless size={Math.max(12, height * 0.12)} />
    </div>
    <div className='bottom'>
      <span>YOUR NAME &nbsp; 06/24</span>
      <span className='visa'>VISA</span>
      <span>•••• •••• •••• 8557</span>
    </div>
  </Root>
);

export default CreditCard;
